import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography,
  IconButton,
  styled,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const GlassDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    background: 'rgba(255, 255, 255, 0.15)',
    backdropFilter: 'blur(20px)',
    borderRadius: 16,
    padding: theme.spacing(2),
    maxWidth: '90%',
    width: 400,
  },
}));

interface AuthDialogProps {
  open: boolean;
  onClose: () => void;
}

const AuthDialog: React.FC<AuthDialogProps> = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    onClose();
    navigate(path);
  };

  return (
    <GlassDialog open={open} onClose={onClose}>
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: 'text.secondary',
        }}
      >
        <CloseIcon />
      </IconButton>
      
      <DialogTitle sx={{ textAlign: 'center', pt: 3 }}>
        Sign in or Register
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 3, textAlign: 'center' }}>
          Please sign in or create an account to access this feature
        </Typography>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button
            variant="contained"
            fullWidth
            onClick={() => handleNavigation('/login')}
            sx={{
              backgroundColor: 'primary.main',
              color: 'text.light',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            Sign In
          </Button>
          
          <Button
            variant="outlined"
            fullWidth
            onClick={() => handleNavigation('/register')}
            sx={{
              borderColor: 'primary.main',
              color: 'text.primary',
              '&:hover': {
                borderColor: 'primary.dark',
                backgroundColor: 'primary.light',
              },
            }}
          >
            Register
          </Button>
        </Box>
      </DialogContent>
    </GlassDialog>
  );
};

export default AuthDialog; 